app.OrgDetailsView = app.BaseDetailsView.extend({
  initialize() {
    app.BaseDetailsView.prototype.initialize.apply(this, arguments);

    // Listen for the locations to be loaded so we can render the location dropdowns in web and
    // catering settings
    this.listenTo(app.locationList, 'reset', (/* e */) => {
      if (this.$el.html().length) {
        this.render();
      }
    });

    if (app.sessionUser.isBite() || app.org.get('enterpriseTagId')) {
      this.listenTo(app.enterpriseTagList, 'reset', (/* e */) => {
        if (this.$el.html().length) {
          this.render();
        }
      });
    }
  },

  getSchema() {
    const schema = app.JsonHelper.deepClone(app.BaseDetailsView.prototype.getSchema.apply(this));

    return schema;
  },
});
